import { ReactNode } from "react";
import { SxProps, Theme } from "@mui/material";

/** Flex gap + zero physical margins so icon/text spacing works in RTL and LTR. */
export const RTL_ICON_BUTTON_SX: SxProps<Theme> = {
  gap: 1.25,
  "& .MuiButton-startIcon, & .MuiButton-endIcon": {
    margin: 0,
  },
};

/** Inline icon + label row (headers, chips, stat rows). */
export const RTL_ICON_LABEL_GROUP_SX: SxProps<Theme> = {
  display: "inline-flex",
  alignItems: "center",
  gap: 1.25,
  minWidth: 0,
};

/**
 * MUI already mirrors startIcon to the reading-start edge when theme.direction is rtl.
 * Always pass startIcon — swapping to endIcon in Arabic puts the icon on the wrong side.
 */
export function rtlIconButtonProps(_isRTL: boolean, icon: ReactNode) {
  return { startIcon: icon };
}

/** Leading icon inside compact search/filter rows. */
export const RTL_INPUT_ICON_SX: SxProps<Theme> = {
  margin: 0,
  marginInlineEnd: 1,
  flexShrink: 0,
};

/** Align a popover to the inline-end of its trigger (language/support menus). */
export function popoverOriginEnd(isRTL: boolean) {
  const horizontal = isRTL ? ("left" as const) : ("right" as const);
  return {
    anchorOrigin: { vertical: "bottom" as const, horizontal },
    transformOrigin: { vertical: "top" as const, horizontal },
  };
}
